// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-input-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.tag-input-container .tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.tag-input-container .tag {
  display: flex;
  align-items: center;
  background-color: #97a4b53e;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  color: #323e59;
  line-height: 1.5;
  margin: 2px 0 8px;
  font-weight: 500;
}

.tag-input-container .tag-remove {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #8c93a3;
}

.tag-input-container .tag-input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.tag-input-container .suggestion-list {
  list-style: none;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 120px;
  overflow-y: auto;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0px 3px 10px #00000033;
  border-radius: 6px;
}
.tag-input-container .suggestion-list-label {
  font-size: 13px;
  line-height: 18px;
  color: #7f8b9b;
  padding: 8px 14px;
  background: #fff;
}
.tag-input-container .suggestion {
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  color: #222222;
  font-weight: 500;
}

.tag-input-container .suggestion:hover {
  background-color: #f8f9fa;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierUploadForm/tagInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".tag-input-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.tag-input-container .tag-list {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.tag-input-container .tag {\n  display: flex;\n  align-items: center;\n  background-color: #97a4b53e;\n  border-radius: 4px;\n  padding: 5px 10px;\n  font-size: 14px;\n  color: #323e59;\n  line-height: 1.5;\n  margin: 2px 0 8px;\n  font-weight: 500;\n}\n\n.tag-input-container .tag-remove {\n  margin-left: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #8c93a3;\n}\n\n.tag-input-container .tag-input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.tag-input-container .suggestion-list {\n  list-style: none;\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  max-height: 120px;\n  overflow-y: auto;\n  background-color: #fff;\n  z-index: 1;\n  box-shadow: 0px 3px 10px #00000033;\n  border-radius: 6px;\n}\n.tag-input-container .suggestion-list-label {\n  font-size: 13px;\n  line-height: 18px;\n  color: #7f8b9b;\n  padding: 8px 14px;\n  background: #fff;\n}\n.tag-input-container .suggestion {\n  padding: 8px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #222222;\n  font-weight: 500;\n}\n\n.tag-input-container .suggestion:hover {\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
